import { cn } from '@/lib/utils';

interface OsvitlyLogoProps {
  className?: string;
  /** Override the icon size (default `size-7`). */
  iconClassName?: string;
  /** Override the wordmark type styles (default `text-[1.05rem]`). */
  wordmarkClassName?: string;
  /** Show the wordmark on every breakpoint (default hides it below `sm`). */
  alwaysShowWordmark?: boolean;
}

/**
 * Osvitly platform logo — the shared brand mark (open book on the deep-green
 * brand tile, same geometry as the landing's Logo.astro) + wordmark. Colors
 * come from the theme tokens so the mark tracks light/dark automatically.
 */
export function OsvitlyLogo({
  className,
  iconClassName,
  wordmarkClassName,
  alwaysShowWordmark = false,
}: OsvitlyLogoProps) {
  return (
    <span className={cn('flex items-center gap-2.5', className)}>
      <svg
        viewBox="0 0 32 32"
        className={cn('size-7 shrink-0', iconClassName)}
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <rect x="0.5" y="0.5" width="31" height="31" rx="8" fill="hsl(var(--primary))" />
        {/* Open book: two facing pages under the "O" of Osvitly. */}
        <path
          d="M7 11.5c3-1.6 6-1.6 9 0v10c-3-1.6-6-1.6-9 0v-10Z"
          fill="#ffffff"
          fillOpacity="0.92"
        />
        <path
          d="M25 11.5c-3-1.6-6-1.6-9 0v10c3-1.6 6-1.6 9 0v-10Z"
          fill="#ffffff"
          fillOpacity="0.72"
        />
        <line
          x1="16"
          y1="11.5"
          x2="16"
          y2="21.5"
          stroke="hsl(var(--primary))"
          strokeWidth="1"
          strokeOpacity="0.5"
        />
      </svg>
      <span
        className={cn(
          'text-[1.05rem] font-semibold tracking-tight',
          alwaysShowWordmark ? 'inline' : 'hidden sm:inline',
          wordmarkClassName
        )}
      >
        Osvit<span className="text-primary">ly</span>
      </span>
    </span>
  );
}
